import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";

import Home from "./pages/home/home";
import Productdetails from "./pages/product-details/productdetails";
import Productgrid from "./pages/product-grid/productgrid";
import Contactus from "./pages/contactus/contactus";
import Offer from "./pages/offers/offer";
import AboutUs from "./pages/aboutus/aboutus";
import Login from "./pages/login/login";
import Signup from "./pages/signup/signup";
import Cart from "./pages/cart/cart";
import Checkout from "./pages/checkout/checkout";
import Brands from "./pages/brands/brands";
import OrderTracking from "./pages/ordertraking/OrderTracking"; // Add this import
import OrderSuccess from "./pages/OrderSuccess/OrderSuccess";
import AdminHome from "./dashboard/components/home/home";
import AdminLogin from "./dashboard/components/login/login"; // Add this import
import AdminProduct from "./dashboard/components/product/product"; // Add this import
/* ✅ CREATE guestId ONCE */
let guestId = localStorage.getItem("guestId");
if (!guestId) {
  guestId = crypto.randomUUID();
  localStorage.setItem("guestId", guestId);
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Router>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/aboutus" element={<AboutUs />} />

      {/* ✅ OLD ID ROUTE (keep if still used anywhere) */}
      <Route path="/product-details/:id" element={<Productdetails />} />

      {/* ✅ NEW SAFE ROUTE (category + subcategory) */}
      <Route
        path="/product/:category/:subcategory"
        element={<Productdetails />}
      />

      <Route path="/shop" element={<Productgrid />} />
      <Route path="/offers" element={<Offer />} />
      <Route path="/contactus" element={<Contactus />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/brands" element={<Brands />} />

      {/* Order Tracking Route */}
      <Route path="/track/:orderNumber?" element={<OrderTracking />} />
      <Route path="/order-success" element={<OrderSuccess />} />

      {/* Category routes */}
      <Route path="/category" element={<Productgrid />} />
      <Route path="/category/:category" element={<Productgrid />} />
      <Route path="/products" element={<Productgrid />} />
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminHome />} />
      <Route path="/admin/products" element={<AdminProduct />} />
    </Routes>
  </Router>,
);

reportWebVitals();
